import { sistemaPluviometricoApi } from "../BaseService";
export const getEvents = async (token, categoria) => {
    const api = sistemaPluviometricoApi(token);
    const searchParams = new URLSearchParams();
    categoria?.forEach((categoria) => {
        searchParams.append("categoria", categoria);
    });
    const query = searchParams.toString();
    const response = await api.get(query ? `/evento/mapa?${query}` : "/evento/mapa");
    return response.data;
};
export const getEventByID = async (id, token) => {
    const api = sistemaPluviometricoApi(token);
    const response = await api.get(`/evento/${id}`);
    return response.data;
};
export const getEventHistory = async (id, categoria, subcategoria, dias, page, size, token) => {
    const api = sistemaPluviometricoApi(token);
    const searchParams = new URLSearchParams();
    if (id)
        searchParams.append("id", String(id));
    categoria?.forEach((categoria) => {
        searchParams.append("categoria", categoria);
    });
    subcategoria?.forEach((subcategoria) => {
        searchParams.append("subcategoria", subcategoria);
    });
    if (dias)
        searchParams.append("dias", String(dias));
    if (page !== undefined)
        searchParams.append("page", String(page));
    if (size !== undefined)
        searchParams.append("size", String(size));
    const response = await api.get(`/evento/historico?${searchParams.toString()}`);
    return response.data;
};
export const patchEvent = async (payload, token) => {
    const api = sistemaPluviometricoApi(token);
    const formData = new FormData();
    formData.append("id", String(payload.id));
    formData.append("latitude", payload.latitude);
    formData.append("longitude", payload.longitude);
    formData.append("cidade", payload.cidade);
    if (payload.bairro) {
        formData.append("bairro", payload.bairro);
    }
    if (payload.observacao) {
        formData.append("observacao", payload.observacao);
    }
    payload.listaAnexo.forEach((anexo, index) => {
        if (anexo.anexo) {
            formData.append(`listaAnexo[${index}].anexo`, anexo.anexo);
        }
        if (anexo.id && anexo.id !== 0) {
            formData.append(`listaAnexo[${index}].id`, String(anexo.id));
        }
        formData.append(`listaAnexo[${index}].tipo`, anexo.tipo);
    });
    const response = await api.patch(`/evento/${payload.id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};
export const postEvent = async (payload, token) => {
    const api = sistemaPluviometricoApi(token);
    const formData = new FormData();
    formData.append("categoriaEvento", payload.categoriaEvento);
    payload.subcategoriaEventos.forEach((subcategoria) => {
        formData.append("subcategoriaEventos", subcategoria);
    });
    formData.append("dataEvento", payload.dataEvento);
    formData.append("horaEvento", payload.horaEvento);
    formData.append("cidade", payload.cidade);
    if (payload.bairro) {
        formData.append("bairro", payload.bairro);
    }
    formData.append("latitude", payload.latitude);
    formData.append("longitude", payload.longitude);
    if (payload.observacao) {
        formData.append("observacao", payload.observacao);
    }
    payload.listaAnexo.forEach((anexo, index) => {
        if (anexo.anexo) {
            formData.append(`listaAnexo[${index}].anexo`, anexo.anexo);
        }
        formData.append(`listaAnexo[${index}].tipo`, anexo.tipo);
    });
    const response = await api.post(`/evento`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};
export const getDeletedEventsNotification = async (token) => {
    const api = sistemaPluviometricoApi(token);
    const response = await api.get("/evento/notificacoes-exclusao");
    return response.data;
};
